export enum LinkMobilePluginOption {
  InAppBrowser = "inAppBrowser",
  FileViewer = "fileViewer"
}

export interface LinkOptions {
  target?: "_self" | "_blank";
  mobilePlugin?: LinkMobilePluginOption;
}

export interface LinkPlugin {
  open (
    url: string,
    options?: LinkOptions
  ): Promise<void>;
}